import { AddonPlanData } from '@/features/subscriptions/types/subscription-types';

export type AddonType =
  | 'extra_seat'
  | 'extra_subproject'
  | 'extra_derivative_kpi';

export const addonsPlans: AddonPlanData[] = [
  {
    id: 'extra_seat',
    type: 'addon',
    planType: 'extra_seat',
    hasTrial: false,
  },
  {
    id: 'extra_subproject',
    type: 'addon',
    planType: 'extra_subproject',
    hasTrial: false,
  },
  {
    id: 'extra_derivative_kpi',
    type: 'addon',
    planType: 'extra_derivative_kpi',
    hasTrial: false,
  },
];
